<template>
  <router-view />
</template>

<script>
export default {
  name: 'exertises-avb',
}
</script>
